import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import DataContainer from 'Components/UI/DataContainer';
import useCollectionState from 'Hooks/useCollectionState';
import LoadingIndicator from 'Components/UI/LoadingIndicator';
import { FDStack } from '@facet-wealth/design';
import { AccountInstitution } from './AccountInstitution';


export const AccountInstitutionContainer = (props) => {
  const { resource, ...restProps } = props;
  const {
    collection, loading, loadingError, refreshCollection,
  } = useCollectionState({ link: resource.relationship(fr.relationships.linkedInstitution.name)?.link('related') });

  return (
    <DataContainer
      component={AccountInstitution}
      loading={loading && !collection}
      loadingError={loadingError}
      skeleton={() => ( // The default loading indicator causes the page to be janky, these adjustments make it much more smooth
        <FDStack width="100%" justifyContent={restProps.horizontalAlignment ?? 'flex-end'}>
          <LoadingIndicator spacing={false} />
        </FDStack>
      )}
      componentProps={{
        refreshCollection,
        collection,
        ...restProps,
      }}
    />
  );
};

AccountInstitutionContainer.defaultProps = {
};

AccountInstitutionContainer.propTypes = {
  resource: PropTypes.object.isRequired, // account resource
};
